<script setup>
    import { inject, onBeforeMount, onMounted, reactive, ref } from 'vue'
    import { Navigation, Footer } from '@/js/components'
    import FrameError from '@/js/components/FrameError.js'

    import { useRoute, useRouter } from 'vue-router'
    import { GlobalNotifications } from '@/js/components/Common'
    import { useAlertStore } from '@/js/stores'

    const errorData = reactive(null)
    const showError = ref(false)
    const isOldServer = process.env.DEPLOY_ENV === 'pre'
    const alertStore = useAlertStore()

    const oldToasterValue = ref('')
    const axios = inject('axios')
    const router = useRouter()
    const route = useRoute()

    onMounted(() => {})

    onBeforeMount(() => {
        axios.interceptors.response.use(undefined, (err) => {
            if (route.name === 'Logout') {
                return Promise.reject(err.response)
            }
            if (err.response && err.response.status && err.response.data) {
                if (
                    (403 === err.response.status &&
                        'Your token is invalid, please login again to get a new one' ===
                            err.response.data.message &&
                        route.name !== 'Logout') ||
                    (401 === err.response.status &&
                        'Expired JWT Token' === err.response.data.message)
                ) {
                    alertStore.info(
                        'Dies ist passiert, da Ihre letzte Anmeldung zu lange her ist. Bitte melden Sie sich erneut an.',
                        'Sie wurden automatisch abgemeldet.'
                    )

                    router.push({ name: 'Logout' })
                    return
                }
                if ('Switch User failed: ' === err.response.data.detail) {
                    router.push({ name: 'Logout' })
                    return
                }
            }

            return Promise.reject(err.response)
        })
    })

    function showSnackbar(error) {
        let message = ''
        let isProd = process.env.NODE_ENV === 'production'
        if (isProd) {
            message = `Wenden Sie sich bitte an lernleitstand@lernleitstand.de`
        } else {
            message = `
            Fehlermeldung: ${error.message}
            Stacktrace: ${error.stack}
            `
        }
        if (message !== oldToasterValue.value) {
            alertStore.error(message, 'Sie wurden automatisch abgemeldet.')
        }
        oldToasterValue.value = message
    }
</script>

<template>
    <FrameError @error="showSnackbar">
        <v-app class="text-grey">
            <v-alert
                v-if="showError"
                class="position-fixed fixed-top ma-0 rounded-0"
                style="z-index: 2000"
                variant="elevated"
                prominent
                icon="mdi-alert-box"
                color="error"
                closable
            >
                {{ errorData }}
            </v-alert>

            <navigation />

            <v-main class="d-flex flex-column">
                <div v-if="isOldServer" class="server-moved-banner">
                    Hinweis: Der bisherige Pre-Server des Lernleitstands wird in Kürze außer Betrieb
                    genommen und wird nur noch zum Abgleich von Daten zur Verfügung stehen. Alle
                    Daten und Funktionen stehen künftig auf dem Live-Server zur Verfügung:
                    <a href="https://lls.hs-anhalt.de" target="_blank">https://lls.hs-anhalt.de</a>
                    Änderungen an Modulen bzw. Modulhandbüchern werden nur im Live-Server
                    übernommen. Bitte nutzen Sie ab sofort den Live-Server und aktualisieren Sie
                    gegebenenfalls vorhandene Lesezeichen.
                </div>
                <v-container
                    fluid
                    class="pa-1 pa-sm-2 pa-md-4 pa-lg-5 pa-xl-6 pa-xxl-7 flex-grow-1"
                >
                    <vue-page-transition name="fade">
                        <router-view class="px-2 px-sm-3" />
                    </vue-page-transition>
                </v-container>
                <Footer />
            </v-main>
            <global-notifications />
        </v-app>
    </FrameError>
</template>

<style lang="scss" scoped>
    .slide-fade-enter-active {
        transition: all 0.3s ease;
    }

    .slide-fade-leave-active {
        transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
        transform: translateX(10px);
        opacity: 0;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition-property: opacity;
        transition-duration: 0.25s;
    }

    .fade-enter-active {
        transition-delay: 0.25s;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0;
    }

    .my-picker {
        max-width: 250px;
    }

    .server-moved-banner {
        width: 100%;
        background-color: #a62828;
        color: #fff;
        display: grid;
        place-items: center;
        padding: 1rem 2rem;

        p {
            margin: 0;
            text-align: left;
            font-size: 1.25rem;
            font-weight: 500;
        }

        a {
            color: #fff;
            font-size: 1.5rem;
            font-weight: 600;
        }
    }
</style>
